module.exports = __webpack_public_path__ + "img/back_items-sprite-2x.0f29b24c.png";